import VehicleInterface from 'types/Vehicle';
import Vehicle from './Vehicle';

interface Props {
  vehicles: VehicleInterface[];
  onVehicleClick?: (vehicle: VehicleInterface) => void;
}

function MobileSearchResultsCarousel({ vehicles, onVehicleClick }: Props): JSX.Element {
  return (
    <div className="vehicles" data-testid="mobile-carousel">
      <div className="scrolling-container">
        <div className="inner-scrolling-container">
          {vehicles.map((vehicle, index) => (
            <Vehicle
              {...vehicle}
              key={vehicle.vin}
              onClick={(): void => {
                if (!onVehicleClick) {
                  return;
                }

                onVehicleClick({
                  position: index + 1,
                  targetPageUrl: vehicle.vdp_url,
                });
              }}
            />
          ))}
        </div>
      </div>
      <style jsx>{`
        .vehicles {
          margin-top: 30px;
          width: 100%;
        }

        .scrolling-container {
          overflow-x: scroll;
          overflow-y: hidden;
          height: 270px;
          -webkit-overflow-scrolling: touch;
        }

        .inner-scrolling-container {
          width: 9999px;
        }
      `}</style>
    </div>
  );
}

export default MobileSearchResultsCarousel;
